import { Component, OnInit } from '@angular/core';

import { Controllers } from '@shared/core/controllers';

import { Observable } from 'rxjs';
import { startWith, delay, map } from 'rxjs/operators';

@Component({
    selector: 'shared-loyalty-for-member-free-products',
    templateUrl: './loyalty-for-member-free-products.shared.component.html',
    styleUrls: ['./loyalty-for-member-free-products.shared.component.scss']
})
export class LoyaltyForMemberFreeProductsComponent implements OnInit {
    public freeProducts$!: Observable<OLO.Ordering.ILoyaltyFreeProductItemModel[]>;
    public loading$: Observable<boolean>;

    constructor(
        public controllers: Controllers,
    ) {

    }

    ngOnInit(): void {
        this.freeProducts$ = this.controllers.loyalty.getCurrentMemberLoyaltyFreeProductsGrouped$()
            .pipe(
                startWith(null),
                delay(0),
            );

        this.loading$ = this.controllers.loyalty.isLoadingLoyaltyInfoForMember$();
    }
}
